import React from 'react';
import { Badge } from 'reactstrap';
import Card from '../../../../components/Card/Card';
import { STATIC_PATH } from '../../../../config';

const src = `${STATIC_PATH}/img/payment-data`;

const iconPath = type => {
  switch (type) {
    case 1:
    case 15:
    case 27:
      return 'WebMoney.svg';
    case 3:
      return 'credit-card-ru.svg';
    case 4:
      return 'yoomoney.svg';
    case 5:
      return 'qiwi.png';
    case 11:
      return 'epayments.svg'; //usd
    case 28:
      return 'epayments.svg'; //eur
    case 29:
    case 36:
      return 'zeley-cash.webp';
    case 30:
      return 'credit-card-ua.svg';
    case 31:
    case 32:
    case 33:
      return 'Capitalist.png';
    case 34:
      return 'entryprofit.png';
    case 35:
      return 'viztrom.png';
    case 37:
       return 'credit-card-kz.svg'
    default:
      return 'default.svg';
  }
};

const renderCurrencyBadge = type => {
  const eurWallets = [27, 28, 33];
  const usdWallets = [15, 11, 32];

  if (eurWallets.includes(type)) {
    return (
      <Badge color="primary" className="currency" pill>
        EUR
      </Badge>
    );
  } else if (usdWallets.includes(type)) {
    return (
      <Badge color="secondary" className="currency" pill>
        USD
      </Badge>
    );
  }
};

const getWalletComission = commission => (commission === '0' ? commission + '%' : commission);

export default ({ wallet, selectPurse, selected }) => (
  <Card tag="a" onClick={e => selectPurse(wallet.type)} style={{ cursor: 'pointer' }}>
    <Card.Body className={`payment-nav-item-body ${selected ? `active` : ''}`}>
      <img className="payment-data-logo" src={`${src}/${iconPath(wallet.type)}?1`} />
      <Badge className="commission" pill>
        {getWalletComission(wallet.commissionText ? wallet.commissionText : wallet.commission)}
      </Badge>
      {renderCurrencyBadge(wallet.type)}
    </Card.Body>
  </Card>
);
